<template>
  <v-navigation-drawer app clipped right stateless :value="true">
    <v-container>
      <!-- <CourseEditForm :course="course" /> -->
      <v-divider class="divider"></v-divider>
      <v-btn class="action-btn" color="success" block>Dodaj</v-btn>
      <v-btn class="action-btn" color="error" block>Anuluj</v-btn>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
// import CourseEditForm from '@/components/manage/courses/right-panel/CourseEditForm.vue';

export default {
  data: function() {
    return {
      course: {
        name: ''
      }
    };
  },
  components: {
    // CourseEditForm
  }
};
</script>

<style lang="scss" scoped>
.divider {
  margin-top: 16px;
  margin-bottom: 16px;
}

.action-btn {
  margin-top: 8px;
  margin-bottom: 8px;
}
</style>
